import { render, staticRenderFns } from "./EstablishmentInternalOrderStatusBadge.vue?vue&type=template&id=4b6709e3"
import script from "./EstablishmentInternalOrderStatusBadge.vue?vue&type=script&lang=js"
export * from "./EstablishmentInternalOrderStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports